import { render, staticRenderFns } from "./OfficeServe.vue?vue&type=template&id=bd0d486a&scoped=true&"
import script from "./OfficeServe.vue?vue&type=script&lang=js&"
export * from "./OfficeServe.vue?vue&type=script&lang=js&"
import style0 from "./OfficeServe.vue?vue&type=style&index=0&id=bd0d486a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0d486a",
  null
  
)

export default component.exports